import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider, ReCaptchaV3Provider } from 'firebase/app-check';
import { getAuth } from 'firebase/auth';
import { getFirestore, setLogLevel } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';
import { getDatabase } from 'firebase/database';
import { FIREBASE_STORAGE_BUCKET } from './storageUrls';

const firebaseConfig = {
  apiKey: "AIzaSyDt6d58d3cfdqTebItYF10t-zd3a72WaS4",
  authDomain: "kinship-8dd5c.firebaseapp.com",
  databaseURL: "https://kinship-8dd5c-default-rtdb.firebaseio.com",
  projectId: "kinship-8dd5c",
  storageBucket: FIREBASE_STORAGE_BUCKET,
  messagingSenderId: "209550879053",
  appId: "1:209550879053:web:2bb08670e03fa4d04e6f04",
  measurementId: "G-0X2VYPQ0DW"
};

const app = initializeApp(firebaseConfig);
// This is a PUBLIC, domain-restricted site key, not a server/API secret.
// Registered with this Firebase web app's reCAPTCHA Enterprise App Check provider.
const defaultAppCheckSiteKey = '6LeTggYuAAAAAI-7RW4gIyGgwC0bpJmDNGDp7Q82';
const appCheckSiteKey = process.env.REACT_APP_FIREBASE_APP_CHECK_SITE_KEY || defaultAppCheckSiteKey;
const useLegacyV3 = Boolean(process.env.REACT_APP_FIREBASE_APP_CHECK_SITE_KEY)
  && process.env.REACT_APP_FIREBASE_APP_CHECK_PROVIDER !== 'enterprise';
// Initialize before Auth/Firestore/Functions so every SDK shares the attestation provider.
export const appCheck = initializeAppCheck(app, {
  provider: useLegacyV3 ? new ReCaptchaV3Provider(appCheckSiteKey) : new ReCaptchaEnterpriseProvider(appCheckSiteKey),
  isTokenAutoRefreshEnabled: true,
});
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);
export const realtimeDb = getDatabase(app);

// Reduce console noise from Firebase connection retries
// Set to 'error' to only show actual errors, or 'warn' to see warnings too
if (process.env.NODE_ENV === 'production') {
  setLogLevel('error'); // Only errors in production
} else {
  // In development, filter out expected network retry warnings
  const originalWarn = console.warn;
  console.warn = (...args: any[]) => {
    const message = args.join(' ');
    // Filter out expected Firebase retry messages
    if (
      message.includes('transport errored') ||
      message.includes('WebChannelConnection') ||
      message.includes('ERR_QUIC_PROTOCOL_ERROR') ||
      message.includes('ERR_INTERNET_DISCONNECTED')
    ) {
      // Suppress these expected retry warnings
      return;
    }
    originalWarn.apply(console, args);
  };
}

export default app;
